export default __webpack_public_path__ + "static/gradient_bg-9a65c61bfb0a9042152eef91701ac8bf.png";